import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Card,
  TextField,
  Paper
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { IVehicleService } from '../../../services/Interfaces/IVehicleService';
import { ClaimBoxAdvertiser, ClaimBoxAdvertiserFilters, ClaimBoxAdvertiserImportedDto, ClaimBoxAdvertiserImportRequestDto, ImportClaimBoxAdvertiserAttachment } from '../../../interfaces/Vehicle';
import * as R from 'ramda';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import MaterialTable from 'material-table';
import { getLocalization, MaterialTableIcons } from '../../_shared/TableSettings';
import { CloudUploadOutlined } from '@material-ui/icons';

interface IClaimBoxAdvertiserState {
  newClaimBoxAdvertiser: ClaimBoxAdvertiser;
  claimBoxAdvertisers: ClaimBoxAdvertiser[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newClaimBoxAdvertiserId: number | null;
  entityCodes: IReferential[];
  advertisers: IReferential[];
  entityCodeValuesMap: Record<string, IReferential[]>; 
  page: number;
  pageSize: number;
  count: number;
  selectedAdvertisers: IReferential[];
  selectedEntityCode: IReferential | null;
  selectedClaimBoxes: IReferential[];
  isLoadingImportData: boolean;
  isImportDialogOpen: boolean;
  attachments: ImportClaimBoxAdvertiserAttachment[];
  importedClaimBoxAdvertiserList: ClaimBoxAdvertiserImportedDto[];  
}
type IClaimBoxAdvertiserProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class ClaimBoxAdvertiserComponent extends React.PureComponent<
  IClaimBoxAdvertiserProps,
  IClaimBoxAdvertiserState
> {
  private translatorService!: ITranslatorService;
  private appReferentialService!: IReferentialService;
  private vehicleService!: IVehicleService;

  static contextType = ApplicationContext;
  private newClaimBoxAdvertiser = {
    id: 0,
    advertiserId: 0,
    claimBox: null,
    advertiser: null,
    entityCode: '',
    entityCodeReferential: null,
    externalId: '',
    claimBoxId: 0,
    gtId: 1
  } as ClaimBoxAdvertiser;

  state = {
    claimBoxAdvertisers: [],
    isLoading: false,
    selectedFilter: 0,
    isDialogOpen: false,
    newClaimBoxAdvertiser: this.newClaimBoxAdvertiser,
    newClaimBoxAdvertiserId: null,
    entityCodes: [] as IReferential[],
    advertisers: [] as IReferential[],
    entityCodeValuesMap: {} as Record<string, IReferential[]>,
    page: 0,
    pageSize: 10,
    count: 1,
    selectedAdvertisers: [] as IReferential[],
    selectedEntityCode: null,
    selectedClaimBoxes: [] as IReferential[],
    isLoadingImportData: false,
    isImportDialogOpen: false,
    attachments: [] as ImportClaimBoxAdvertiserAttachment[],
    importedClaimBoxAdvertiserList: [] as ClaimBoxAdvertiserImportedDto[]
  } as IClaimBoxAdvertiserState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

 loadData = async () => {
    const entityCodeValuesMap: Record<string, IReferential[]> = {};
    const entityCodeRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.EntityType
    );
    const advertiserRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Advertiser
    );
    const filters = {
      advertiserIds: this.state.selectedAdvertisers.map((item) => item.id),
      entityCodes: this.state.selectedEntityCode ? [this.state.selectedEntityCode.code] : [],
      claimBoxIds: this.state.selectedClaimBoxes.map((item) => item.id),
      page: this.state.page + 1,
      pageSize: this.state.pageSize
    } as ClaimBoxAdvertiserFilters;
    const [claimBoxAdvertisersList, advertisers, entityCodes] = await Promise.all([
      this.vehicleService.GetClaimBoxAdvertisers(filters),
      this.appReferentialService.Get(advertiserRef!.baseUrl),
      this.appReferentialService.Get(entityCodeRef!.baseUrl)
    ]);

    const claimBoxAdvertisers = claimBoxAdvertisersList.claimBoxAdvertisers;

    await Promise.all(
      entityCodes.map(async (entityCode) => {
        if (R.isNil(entityCode.code)) {
          return;
        }
        const ref = Referentials.referential.find(
          (item) => item.code === entityCode.code
        );
        const values = await this.appReferentialService.Get(ref!.baseUrl);
        entityCodeValuesMap[entityCode.code] = values;
      })
    );

    claimBoxAdvertisers.forEach(item => {
      const advertiser = advertisers.find(advertiser => !R.isNil(item.advertiserId) && advertiser.id === item.advertiserId);
      const referential = entityCodeValuesMap[item.entityCode] && entityCodeValuesMap[item.entityCode].length > 0 ? entityCodeValuesMap[item.entityCode].find(entity => entity.id === item.claimBoxId) : null;
      const entityCodeReferential = entityCodes.find(entity => entity.code === item.entityCode);

      item.advertiser = R.isNil(advertiser) ? null : advertiser;
      item.claimBox = R.isNil(referential) ? null : referential;
      item.entityCodeReferential = R.isNil(entityCodeReferential) ? null : entityCodeReferential;
    });  

    this.setState({
      claimBoxAdvertisers: claimBoxAdvertisers,
      page: claimBoxAdvertisersList.page - 1,
      count: claimBoxAdvertisersList.total,
      pageSize: this.state.pageSize,
      isLoading: false,
      newClaimBoxAdvertiser: { ...this.newClaimBoxAdvertiser },
      entityCodes: entityCodes,
      entityCodeValuesMap: entityCodeValuesMap,
      advertisers: advertisers
    });
  };

  reloadClaimBoxAdvertisers = async (page: number, rowsPerPage: number) => {
    this.setState({ isLoading: true});

    const filters = {
      advertiserIds: this.state.selectedAdvertisers.map((item) => item.id),
      entityCodes: this.state.selectedEntityCode ? [this.state.selectedEntityCode.code] : [],
      claimBoxIds: this.state.selectedClaimBoxes.map((item) => item.id),
      page: page + 1,
      pageSize: rowsPerPage
    } as ClaimBoxAdvertiserFilters;

    const claimBoxAdvertisersList = await this.vehicleService.GetClaimBoxAdvertisers(filters);
    const claimBoxAdvertisers = claimBoxAdvertisersList.claimBoxAdvertisers;

    claimBoxAdvertisers.forEach(item => {
      const advertiser = this.state.advertisers.find(advertiser => !R.isNil(item.advertiserId) && advertiser.id === item.advertiserId);
      const referential = this.state.entityCodeValuesMap[item.entityCode] && this.state.entityCodeValuesMap[item.entityCode].length > 0 ? this.state.entityCodeValuesMap[item.entityCode].find(entity => entity.id === item.claimBoxId) : null;
      const entityCodeReferential = this.state.entityCodes.find(entity => entity.code === item.entityCode);

      item.advertiser = R.isNil(advertiser) ? null : advertiser;
      item.claimBox = R.isNil(referential) ? null : referential;
      item.entityCodeReferential = R.isNil(entityCodeReferential) ? null : entityCodeReferential;
    });  

    this.setState({
      claimBoxAdvertisers: claimBoxAdvertisers,
      isLoading: false,
      page: claimBoxAdvertisersList.page - 1,
      pageSize: rowsPerPage,
      count: claimBoxAdvertisersList.total
    });
  };

  public saveClaimBoxAdvertiser = async () => {
    if (this.state.newClaimBoxAdvertiserId === null) {
      try {
        await this.vehicleService.AddClaimBoxAdvertiser(this.state.newClaimBoxAdvertiser);
        await this.loadData();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.vehicleService.UpdateClaimBoxAdvertiser(this.state.newClaimBoxAdvertiser);
        await this.loadData();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  private handleAdvertiserChange = (newValue: IReferential | null) => {
    this.setState({
      newClaimBoxAdvertiser: {
        ...this.state.newClaimBoxAdvertiser,
        advertiser: newValue,
        advertiserId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleEntityCodeChange = (newValue: IReferential | null) => {
    this.setState({
      newClaimBoxAdvertiser: {
        ...this.state.newClaimBoxAdvertiser,
        entityCodeReferential: newValue,
        entityCode: newValue?.code ?? ""
      }
    });
  };

  private handleClaimBoxChange = (newValue: IReferential | null) => {
    this.setState({
      newClaimBoxAdvertiser: {
        ...this.state.newClaimBoxAdvertiser,
        claimBox: newValue,
        claimBoxId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleExternalIdChange = (value: string) => {
    this.setState({
      newClaimBoxAdvertiser: {
        ...this.state.newClaimBoxAdvertiser,
        externalId: value
      }
    });
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveClaimBoxAdvertiser} instantValidate={true}>
         <Autocomplete
          id="advertiser"
          className="m-2 pr-3"
          fullWidth
          options={this.state.advertisers}
          value={this.state.newClaimBoxAdvertiser.advertiser}
          onChange={(e: any, newValue: IReferential | null) =>
            this.handleAdvertiserChange(newValue)
          }
          getOptionLabel={(option: IReferential) => option.displayName || ''}
          renderInput={(params) => (
            <TextValidator
              {...params}
              name="advertiser"
              value={this.state.newClaimBoxAdvertiser.advertiser}
              label={this.translatorService.Tranlate(
                'CLAIM_BOX_ADVERTISER_ADVERTISER',
                'Client'
              )}
              fullWidth
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate(
                  'VALIDATORS_REQUIRED',
                  'Campul este obligatoriu'
                )
              ]}
            />
          )}
        />

        <Autocomplete
          id="entityCode"
          className="m-2 pr-3"
          fullWidth
          options={this.state.entityCodes}
          value={this.state.newClaimBoxAdvertiser.entityCodeReferential}
          onChange={(e: any, newValue: IReferential | null) =>
            this.handleEntityCodeChange(newValue)
          }
          getOptionLabel={(option: IReferential) => option.displayName || ''}
          renderInput={(params) => (
            <TextValidator
              {...params}
              name="entityCode"
              value={this.state.newClaimBoxAdvertiser.entityCodeReferential}
              label={this.translatorService.Tranlate(
                'CLAIM_BOX_ADVERTISER_ENTITY_CODE',
                'Cod entitate'
              )}
              fullWidth
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate(
                  'VALIDATORS_REQUIRED',
                  'Campul este obligatoriu'
                )
              ]}
            />
          )}
        />

        <Autocomplete
          id="claimBox"
          className="m-2 pr-3"
          fullWidth
          options={this.state.entityCodeValuesMap[this.state.newClaimBoxAdvertiser.entityCode] || []}
          value={this.state.newClaimBoxAdvertiser.claimBox}
          onChange={(e: any, newValue: IReferential | null) =>
            this.handleClaimBoxChange(newValue)
          }
          getOptionLabel={(option: IReferential) => option.displayName || ''}
          renderInput={(params) => (
            <TextValidator
              {...params}
              name="claimBox"
              value={this.state.newClaimBoxAdvertiser.claimBox}
              label={this.translatorService.Tranlate(
                'CLAIM_BOX_ADVERTISER_CLAIM_BOX_ID',
                'Mapare Connect'
              )}
              fullWidth
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate(
                  'VALIDATORS_REQUIRED',
                  'Campul este obligatoriu'
                )
              ]}
            />
          )}
        />

        <TextValidator
          fullWidth
          name="externalId"
          className="m-2 pr-3"
          id="externalId"
          value={this.state.newClaimBoxAdvertiser.externalId || ''}
          onChange={(e: any) => this.handleExternalIdChange(e.target.value)}
          label={this.translatorService.Tranlate(
            'CLAIM_BOX_ADVERTISER_EXTERNAL_ID',
            'Mapare Externa'
          )}
          validators={['required']}
          errorMessages={[
            this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
          ]}
        />

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'advertiser',
        label: this.translatorService.Tranlate(
          'CLAIM_BOX_ADVERTISER_ADVERTISER',
          'Client'
        ),
        options: {
          sort: false,
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : null;
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'entityCode',
        label: this.translatorService.Tranlate(
          'CLAIM_BOX_ADVERTISER_ENTITY_CODE',
          'Cod entitate'
        )
      },
      {
        name: 'claimBox',
        label: this.translatorService.Tranlate(
          'CLAIM_BOX_ADVERTISER_CLAIM_BOX_ID',
          'Mapare Connect'
        ),
        options: {
          sort: false,
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : null;
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'externalId',
        label: this.translatorService.Tranlate(
          'CLAIM_BOX_ADVERTISER_EXTERNAL_ID',
          'Mapare Externa'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newClaimBoxAdvertiserPopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteClaimBoxAdvertiser(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];

    return columns;
  };

  deleteClaimBoxAdvertiser = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.vehicleService.RemoveClaimBoxAdvertiser(id);
      
      await this.reloadClaimBoxAdvertisers(this.state.page, this.state.pageSize);
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newClaimBoxAdvertiserPopup = async (claimBoxAdvertiserId: number | null) => {
    let newClaimBoxAdvertiser: ClaimBoxAdvertiser;
    if (claimBoxAdvertiserId == null) {
      newClaimBoxAdvertiser = { ...this.state.newClaimBoxAdvertiser } as ClaimBoxAdvertiser;
    } else {
      newClaimBoxAdvertiser = this.state.claimBoxAdvertisers.find((item) => item.id === claimBoxAdvertiserId)!;
    }
    this.setState({
      isDialogOpen: true,
      newClaimBoxAdvertiser: newClaimBoxAdvertiser,
      newClaimBoxAdvertiserId: claimBoxAdvertiserId
    });
  };

  closeDialog = async () => {
    this.setState(
      { 
        isDialogOpen: false, 
        newClaimBoxAdvertiser: this.newClaimBoxAdvertiser 
      }
    );
  };

  handleEntityCodesChange = (newValue: IReferential | null) => {
    this.setState(
      {
        selectedEntityCode: newValue,
        isLoading: true
      },
      async () => await this.reloadClaimBoxAdvertisers(this.state.page, this.state.pageSize)
    );
  };

  handleAdvertisersChange = (newValue: any[]) => {
    this.setState(
      {
        selectedAdvertisers: newValue,
        isLoading: true
      },
      async () => await this.reloadClaimBoxAdvertisers(this.state.page, this.state.pageSize)
    );
  };

  handleSelectedClaimBoxes = (newValue: any[]) => {
    this.setState(
      {
        selectedClaimBoxes: newValue,
        isLoading: true
      },
      async () => await this.reloadClaimBoxAdvertisers(this.state.page, this.state.pageSize)
    );
  };


  renderFilters = () => {
    return (
      <div className="mt-3">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box mb={2}>
              <Autocomplete
                id="advertisers"
                size="small"
                multiple
                options={this.state.advertisers}
                value={this.state.selectedAdvertisers}
                onChange={(e: any, newValue: any | null) => this.handleAdvertisersChange(newValue)}
                getOptionLabel={(option: any) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="advertisers"
                    value={this.state.selectedAdvertisers}
                    label={this.translatorService.Tranlate('CLAIM_BOX_ADVERTISER_ADVERTISER', 'Client')}
                    fullWidth
                  />
                )}
              />
            </Box>

            <Box mb={2}>
              <Autocomplete
                id="referentials"
                size="small"
                multiple
                options={this.state.selectedEntityCode && this.state.selectedEntityCode.code ? this.state.entityCodeValuesMap[this.state.selectedEntityCode.code] : []}
                value={this.state.selectedClaimBoxes}
                onChange={(e: any, newValue: any | null) => this.handleSelectedClaimBoxes(newValue)}
                getOptionLabel={(option: any) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="referentials"
                    value={this.state.selectedAdvertisers}
                    label={this.translatorService.Tranlate('CLAIM_BOX_ADVERTISER_CLAIM_BOX_ID', 'Mapare Connect' )}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box mb={2}>
              <Autocomplete
                id="entityCode"
                size="small"
                options={this.state.entityCodes}
                value={this.state.selectedEntityCode}
                onChange={(e: any, newValue: any | null) => this.handleEntityCodesChange(newValue)}
                getOptionLabel={(option: any) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="entityCode"
                    value={this.state.selectedEntityCode}
                    label={this.translatorService.Tranlate('CLAIM_BOX_ADVERTISER_ENTITY_CODE', 'Cod entitate')}
                    fullWidth
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  openImportDialog = async () => {
    this.setState({
      isImportDialogOpen: true,
      isLoadingImportData: false,
      attachments: [],
      importedClaimBoxAdvertiserList: []
    });
  };

  closeImportDialog = async () => {
    this.setState(
      { 
        isImportDialogOpen: false,
        isLoading: true,
        importedClaimBoxAdvertiserList: [],
        attachments: []
      },
      async () => {
        await this.loadData();
      }
    );
  };

  handleDeleteAttachment = async (id: number, fileName: string) => {
    try {
      const attachments = [...this.state.attachments];
      const index = attachments.findIndex((item) => item.id === id);
      attachments.splice(index, 1);

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  canUpload = (): boolean => {
    const files = this.state.attachments;

    if (files.length >= 1) {
      return false;
    }

    return true;
  };

  handleUploadAttachment = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const attachments = [...this.state.attachments];
      attachments.push({
        id: 0,
        file: e.target.files![0],
        fileName: e.target.files![0].name,
        uploadDate: new Date(),
        originalFileName: e.target.files![0].name
      });
      e.target.value = '';

      this.setState({
        attachments: attachments
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderAttachmentBox = () => {
    return (
      <Grid container spacing={2} className="mt-2 mb-5">
        <Grid item xs={9}>
          {this.state.attachments.length !== 0
            ? this.state.attachments.map((attach, index) => {
                return (
                  <div key={index} className="d-flex flex-row w-100">
                    <div className="w-75 text-left">
                      <Button
                        color="primary"
                        className="text-primary text-left pl-0"
                        disabled={false}
                        onClick={(e) => {
                          console.log('download');
                        }}
                      >
                        <span className="crop">{attach.originalFileName}</span>
                      </Button>
                    </div>
                    <div className="w-25">
                      <IconButton
                        aria-label="delete"
                        color="inherit"
                        className="text-danger"
                        size="small"
                        onClick={(e) => {
                          this.handleDeleteAttachment(attach.id, attach.fileName);
                        }}
                        disabled={false}
                      >
                        <DeleteOutlineTwoToneIcon />
                      </IconButton>
                    </div>
                  </div>
                );
              })
            : null}
        </Grid>
        <Grid item xs={3} container justify="flex-end" direction="column">
          <Button
            variant="outlined"
            size="small"
            color="primary"
            className="d-block text-center shadow-none"
            component="div"
            disabled={!this.canUpload()}
          >
            <input
              accept=".xls, .xlsx"
              className="d-none"
              id={'contained-button-file'}
              onChange={(e) => {
                return this.handleUploadAttachment(e);
              }}
              type="file"
              disabled={!this.canUpload()}
            />
            <label
              htmlFor={'contained-button-file'}
              className="w-100 mb-0"
            >
                {this.translatorService.Tranlate(
                'MAVO_VEHICLES_UPLOAD_FILE_BTN_LABEL',
                'Uploadeaza fisier'
              )}
            </label>
          </Button>
        </Grid>
      </Grid>
    );
  };

  handleImport = async () => {
    if (this.state.attachments.length === 0) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG_FILE_NOT_SELECTED', 'Va rugam sa selectati un fisier!'), {
        variant: 'error'
      });
      return;
    }
    this.setState({
      isLoadingImportData: true
    });

    const request = {
      attachments: this.state.attachments
    } as ClaimBoxAdvertiserImportRequestDto;

    try {
      const result = await this.vehicleService.SaveImportedClaimBoxAdvertiser(request);
      this.props.enqueueSnackbar(
        <div>
          <p>
            {this.translatorService.Tranlate('CLAIM_BOX_ADVERTISERS_DATA_PROCESSED', 'Date tratate: ')}{' '}
            {result.totalNumber}
          </p>
          <p>
            {this.translatorService.Tranlate('CLAIM_BOX_ADVERTISERS_TREATED_SUCCESSFULLY', 'Tratate cu succes: ')}{' '}
            {result.importedNumber}
          </p>
        </div>,
        {
          variant: 'info',
          autoHideDuration: 6000
        }
      );
      this.setState({
        importedClaimBoxAdvertiserList: result.claimBoxAdvertiserList,
        isLoadingImportData: false
      });

    } catch {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error',
        autoHideDuration: 6000
      });
      this.setState({
        isLoadingImportData: false
      });
    }
  };

  getImportedColumns = () => {
    return [
      {
        field: 'advertiserName',
        title: this.translatorService.Tranlate(
          'CLAIM_BOX_ADVERTISER_ADVERTISER',
          'Client'
        )
      },
      {
        field: 'entityCode',
        title: this.translatorService.Tranlate(
          'CLAIM_BOX_ADVERTISER_ENTITY_CODE',
          'Cod entitate'
        )
      },
      {
        field: 'claimBoxName',
        title: this.translatorService.Tranlate(
          'CLAIM_BOX_ADVERTISER_CLAIM_BOX_ID',
          'Mapare Connect'
        )
      },
      {
        field: 'externalId',
        title: this.translatorService.Tranlate(
        'CLAIM_BOX_ADVERTISER_EXTERNAL_ID',
        'Mapare Externa'
      )
      },
      {
        field: 'importMessage',
        title: this.translatorService.Tranlate(
          'MAVO_VEHICLES_VEHICLE_IMPORT_MESSAGE',
          'Rezultat import'
        )
      }
    ];
  }

  renderImportedResultBox = () => {
    return this.state.importedClaimBoxAdvertiserList.length > 0 ? (
      <MaterialTable
        columns={this.getImportedColumns()}
        data={this.state.importedClaimBoxAdvertiserList}
        title=""
        icons={MaterialTableIcons}
        localization={getLocalization(this.translatorService)}
        options={{
          actionsColumnIndex: -1,
          addRowPosition: 'first',
          maxBodyHeight: 400,
          paging: false,
          sorting: false,
          search: false
        }}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />
        }}
      />
    ) : '';
  }
  
  public renderImportContent() {
    return (
      <ValidatorForm onSubmit={this.handleImport} instantValidate={true}>
        {this.renderAttachmentBox()}
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingImportData} />
        </div>
        {this.renderImportedResultBox()}
        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeImportDialog}
          >
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_CLOSE_BTN', 'Renunta')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit" 
            disabled={this.state.isLoadingImportData}>
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_BTN', 'Importa')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }
  
  

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.vehicleService = (this.context as AppContext).vehicleService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: false,
      search: false,
      sort: false,
      viewColumns: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      elevation: 0,
      serverSide: true,
      count: this.state.count,
      rowsPerPage: this.state.pageSize,
      page: this.state.page,
      onTableChange: async (action: any, tableState: any) => {
        switch (action) {
          case 'changePage':
            await this.reloadClaimBoxAdvertisers(tableState.page, tableState.rowsPerPage);
            break;
          case 'changeRowsPerPage':
            await this.reloadClaimBoxAdvertisers(tableState.page, tableState.rowsPerPage);
            break;
          case 'sort':
            break;
          default:
        }
      },
      customToolbar: () => {
        return (
          <div>
            <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
              <IconButton
                aria-label="add"
                color="secondary"
                className="m-2"
                onClick={(e) => this.newClaimBoxAdvertiserPopup(null)}
              >
                <AddCircleTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.translatorService.Tranlate('Import', 'Importa')}>
              <IconButton
                aria-label="import"
                color="primary"
                className="m-2"
                onClick={(e) => this.openImportDialog()}
              >
                <CloudUploadOutlined />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <Card>
          <div
            style={{
              backgroundColor: 'var(--primary)',
              fontWeight: 500,
              borderBottom: '4px solid var(--primary-light)'
            }}
            className="card-header text-white text-center"
          >
            <span className="mb-0 py-2">
              {this.translatorService.Tranlate('CLAIM_BOX_ADVERTISERS_TITLE', 'Mapari Publicari')}
            </span>
          </div>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? <div className="ml-3 mr-3">{this.renderFilters()}</div> : null}

          <Box m={1} p={1}>
            <div className="d-flex flex-row text-center flex-wrap justify-content-center">
              <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
            </div>
            {!this.state.isLoading ? (
              <MUIDataTable
                title={''}
                data={this.state.claimBoxAdvertisers}
                columns={this.getColumns()}
                options={options}
              />
            ) : null}
          </Box>
        </Card>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                   <Typography variant="h4">
                    {!this.state.newClaimBoxAdvertiserId ? 
                      this.translatorService.Tranlate(
                        'CLAIM_BOX_ADVERTISER_ADD_MODAL_TITLE',
                        'Adauga Mapare'
                      ) : this.translatorService.Tranlate(
                        'CLAIM_BOX_ADVERTISER_EDIT_MODAL_TITLE',
                        'Editeaza Mapare'
                      )}        
                </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) : null}
          {this.state.isImportDialogOpen ? (
            <Dialog
              onClose={this.closeImportDialog}
              aria-labelledby="customized-dialog-title"
              open={this.state.isImportDialogOpen}
              fullScreen={true}
              fullWidth={true}
              >
              <DialogTitle
                id="customized-dialog-title"
                style={{
                  color: '#ffffff',
                  backgroundColor: 'var(--primary)',
                  textAlign: 'center'
                }}
              >
                <span style={{ fontSize: '20px', lineHeight: '24px' }}>
                  {this.translatorService.Tranlate('CLAIMBOX_ADVERTISER_IMPORT_MODAL_TITLE', 'Importa date')}
                </span>
                <IconButton
                  aria-label="close"
                  className="position-absolute"
                  style={{ right: 12, top: 12, color: '#ffffff' }}
                  onClick={this.closeImportDialog}
                  size={'small'}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Box m={1} p={1}>
                  {this.renderImportContent()}
                </Box>
              </DialogContent>
            </Dialog>
            ) : (
              ''
            )}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(ClaimBoxAdvertiserComponent as any));